import React, { useState, useEffect, useRef } from 'react';
import './ClassicFashion.css';

const ClassicFashion: React.FC = () => {
  const [backgroundPosition, setBackgroundPosition] = useState('center center');
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      if (sectionRef.current) {
        const rect = sectionRef.current.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        const sectionTop = rect.top;
        const sectionHeight = rect.height;
        
        // Tính toán vị trí khi section vào viewport
        if (sectionTop < windowHeight && sectionTop + sectionHeight > 0) {
          // Tính phần trăm scroll trong section
          // Khi section ở trên cùng viewport: scrollProgress = 1
          // Khi section ở dưới cùng viewport: scrollProgress = 0
          const scrollProgress = Math.max(0, Math.min(1, (windowHeight - sectionTop) / (windowHeight + sectionHeight)));
          
          // Di chuyển background chậm hơn (parallax effect)
          // Background di chuyển từ center đến 20% khi scroll
          const yPos = scrollProgress * 20; // Điều chỉnh 20 để thay đổi tốc độ parallax
          setBackgroundPosition(`center ${50 + yPos}%`); // Đảo ngược: di chuyển xuống thay vì lên
        }
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll(); // Gọi ngay để set vị trí ban đầu
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="classic-fashion" ref={sectionRef}>
      <div 
        className="classic-background"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/hero/z7161918827511_4f815384ec91774f9b6fc3b0829a2bd4.jpg)`,
          backgroundPosition: backgroundPosition
        }}
      >
        <div className="classic-overlay">
          <div className="classic-content">
            <p className="classic-subtitle">TỐT NHẤT CỦA</p>
            <h1 className="classic-title">THỜI TRANG CỔ ĐIỂN</h1>
            <p className="classic-description">Khám phá bộ sưu tập móng tay đẹp nhất với thiết kế sang trọng và hiện đại, mang đến vẻ đẹp quyến rũ cho đôi tay của bạn.</p>
            {/* <a href="#shop" className="btn-shop">SHOP NOW</a> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClassicFashion;

